import React, { useRef, useState } from 'react';
import { Button, FormGroup, Label, Table } from 'reactstrap';
import DatePicker, { registerLocale } from "react-datepicker";
import nl from 'date-fns/locale/nl';
import moment from 'moment';
import { ReactComponent as EditIcon } from '../../../../assets/utils/images/svgs/editPen.svg';
import { ReactComponent as CalendarIcon } from '../../../../assets/utils/images/svgs/calendar-blue.svg';
import { formatWtfNl } from '../utils/formatWtf';
import AfasLangeWtfEditModal from './AfasLangeWtfEditModal';
import AfasDagdeelgegevensModal from './AfasDagdeelgegevensModal';
import Loader from "react-loaders";

registerLocale('nl', nl);

const toDate = (value) => (value ? moment(value, 'YYYY-MM-DD').toDate() : null);
const toIso = (date) => (date ? moment(date).format('YYYY-MM-DD') : '');

const AfasLangeVerzoekenPanel = ({
    beginDatum = '',
    eindDatum = '',
    days = [],
    onBeginDatumChange,
    onEindDatumChange,
    onWtfDaysChange,
    isLoading = false,
    dagdeelgegevensRows = [],
}) => {
    const [wtfEditOpen, setWtfEditOpen] = useState(false);
    const [dagdeelgegevensOpen, setDagdeelgegevensOpen] = useState(false);
    const datePickerRefs = useRef([]);

    return (
        <div className="afas-sub-tab-panel afas-lange-verzoeken">
            {isLoading && (
                <div className="afas-lange-verzoeken__loading text-muted small mb-2"><Loader
                    type="ball-grid-pulse"
                    className="mt-3 d-flex mx-auto justify-content-center"
                /></div>
            )}

            <div className="row g-2 mb-3" style={{ maxWidth: '420px' }}>
                <div className="col-sm-6">
                    <FormGroup className="mb-0">
                        <Label htmlFor="afas-lange-begindatum" className="fw-semibold  mb-1">
                            Begindatum
                        </Label>
                        <div className=" customDatePicker">
                            <DatePicker
                                id="afas-lange-begindatum"
                                ref={(el) => (datePickerRefs.current[0] = el)}
                                locale="nl"
                                selected={toDate(beginDatum)}
                                onChange={(val) => onBeginDatumChange?.(toIso(val))}
                                placeholderText="dd-mm-jjjj"
                                dateFormat="dd-MM-yyyy"
                                className="form-control w-100"
                            />
                            <CalendarIcon
                                onClick={() => datePickerRefs.current[0]?.setFocus()}
                                className="svg-pointer"
                            />
                        </div>
                    </FormGroup>
                </div>
                <div className="col-sm-6">
                    <FormGroup className="mb-0">
                        <Label htmlFor="afas-lange-einddatum" className="fw-semibold mb-1">
                            Einddatum
                        </Label>
                        <div className="customDatePicker">
                            <DatePicker
                                id="afas-lange-einddatum"
                                ref={(el) => (datePickerRefs.current[1] = el)}
                                locale="nl"
                                selected={toDate(eindDatum)}
                                onChange={(val) => onEindDatumChange?.(toIso(val))}
                                placeholderText="dd-mm-jjjj"
                                dateFormat="dd-MM-yyyy"
                                className="form-control w-100"
                            />
                            <CalendarIcon
                                onClick={() => datePickerRefs.current[1]?.setFocus()}
                                className="svg-pointer"
                            />
                        </div>
                    </FormGroup>
                </div>
            </div>

            <div className="afas-lange-verzoeken__table-wrap table-responsive rounded">
                <Table hover size="sm" className="mb-0 align-middle
                ">
                    <thead>
                        <tr>
                            <th className="small fw-semibold">Dag</th>
                            <th className="small fw-semibold">WTF / dag</th>
                            <th aria-label="Acties" className="text-center" style={{ width: '50px' }}>
                                Acties
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {days.length === 0 ? (
                            <tr>
                                <td colSpan={3} className="text-center text-muted py-3">
                                    Geen weekdagen
                                </td>
                            </tr>
                        ) : (
                            days.map((row) => (
                                <tr key={row.id || row.dayKey}>
                                    <td >{row.dag}</td>
                                    <td >{formatWtfNl(row.wtf)}</td>
                                    <td className="text-center">
                                        <Button
                                            type="button"
                                            color="link"
                                            size="sm"
                                            className="btn-icon p-0 text-primary"
                                            aria-label="WTF dagen wijzigen"
                                            onClick={() => setWtfEditOpen(true)}
                                        >
                                            <EditIcon width={14} height={14} />
                                        </Button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </div>

            {dagdeelgegevensRows.length > 0 && (
                <div className="mt-2">
                    <Button
                        type="button"
                        color="link"
                        size="sm"
                        className="p-0 text-decoration-none fw-semibold"
                        onClick={() => setDagdeelgegevensOpen(true)}
                    >
                        Dagdeelgegevens tonen
                    </Button>
                </div>
            )}

            <AfasLangeWtfEditModal
                isOpen={wtfEditOpen}
                days={days}
                onClose={() => setWtfEditOpen(false)}
                onSave={(nextDays) => {
                    onWtfDaysChange?.(nextDays);
                    setWtfEditOpen(false);
                }}
            />

            <AfasDagdeelgegevensModal
                isOpen={dagdeelgegevensOpen}
                rows={dagdeelgegevensRows}
                onClose={() => setDagdeelgegevensOpen(false)}
            />
        </div>
    );
};

export default AfasLangeVerzoekenPanel;
